<template>

    <fieldset>

        <div class="form-group right-align">

            <div class="holder">

                <div v-if="editable" class="form-group">

                    <div class="form-check">
                        <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowMultiAnswersScale" id="allow-multi-scale-answers">
                        <label class="form-check-label" for="allow-multi-scale-answers">{{ language.add_scale_type_multiple }}</label>
                    </div>

                </div>

                <div v-if="editable" class="limit-markers">
                    <div class="form-check">
                        <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowLimitMarkers" id="limit-markers">
                        <label class="form-check-label" for="limit-markers">{{ language.add_type_limit_markers }}</label>
                    </div>
                </div>

                <div v-if="editable && dataStore.allowLimitMarkers && dataStore.allowMultiAnswersScale" class="col-12 range-control">
                    <input type="range" min="1" max="20" v-model="dataStore.amountAnswers" class="control" id="amount-answers">
                    <label for="amount-answers">{{ language.add_type_limit_amount_scale.replacePlaceholders({ number : dataStore.amountAnswers }) }}</label>
                </div>

                <div class="form-group">

                    <div v-if="editable" class="choices">

                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="type-of-scale" id="type-of-scale" v-model="dataStore.activeScaleType" value="DEFAULT" :checked="'DEFAULT' == dataStore.activeScaleType">
                            <label class="form-check-label" for="type-of-scale">
                                {{ language.add_scale_type_options_default }}
                            </label>
                        </div>

                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="type-of-scale" id="type-of-scale" v-model="dataStore.activeScaleType" value="CUSTOM" :checked="'CUSTOM' == dataStore.activeScaleType">
                            <label class="form-check-label" for="type-of-scale">
                                {{ language.add_scale_type_options_custom }}
                            </label>
                        </div>

                    </div>

                    <new-search-and-add v-if="dataStore.activeScaleType === 'CUSTOM'" :model="'scaleOption'" :placeholder="language.add_scale_type_add_option" :name="'add-scale-options'" :type="'Option'" :column="'value'" />

                    <div v-if="dataStore.activeScaleType === 'DEFAULT'" v-html="language.add_scale_type_options"></div>

                </div>

            </div>

        </div>

    </fieldset>

</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import NewSearchAndAdd from './../NewSearchAndAdd'

const _ = require('lodash');

export default {

    components: {
        NewSearchAndAdd
    },

    mounted() {

        if(this.dataStore.project.scaleOptions.length) {
           this.dataStore.activeScaleType =  'CUSTOM';
        }

    },

    data() {
        return {
            dataStore,
            globalFunctions
        }
    },

    inject: [ 'language', 'superadmin' ],

    computed: {
        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    },

    methods : {

        addToList: function(prop, value, name){

            let val = _.get(this.$data, prop);

            if(value !== ''){
                val.push(value);
                _.set(this.$data, name, '');
            }
        },

        removeFromList: function(e, prop, value) {

            e.stopPropagation();
            let val = _.get(this.$data, prop);

            if(this.editable) {
                let index = val.indexOf(value);
                val.splice(index, 1);
            }

        },

    }
};
</script>


